import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Equipment from "@/pages/Equipment";
import Approach from "@/pages/Approach";
import Learn from "@/pages/Learn";
import Mrv from "@/pages/Mrv";
import Team from "@/pages/Team";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="services" element={<Approach />} />
            <Route path="advisory" element={<Navigate to="/services#disciplines" replace />} />
            <Route path="equipment" element={<Equipment />} />
            <Route path="mrv" element={<Mrv />} />
            <Route path="technology" element={<Navigate to="/equipment" replace />} />
            <Route path="approach" element={<Navigate to="/services" replace />} />
            <Route path="learn" element={<Learn />} />
            <Route path="team" element={<Team />} />
            <Route path="contact" element={<Contact />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
